<template>
    <component
        :is="version"
        :contest="contest"
        :user="user"
    ></component>
</template>

<script>
import Stub from './Stub';

import { mapGetters, mapActions } from 'vuex';

const getters = [
    'is_collapsed',
    'contest',
    'user',
];

const actions = [
    'loadContest',
];

export default {
    name: 'AcceptContest',
    computed: {
        ...mapGetters(getters),
        version() {
            return this.is_collapsed
                ? 'MobileAcceptContest'
                : 'WideAcceptContest';
        },
    },
    methods: {
        ...mapActions(actions),
    },
    components: {
        MobileAcceptContest: () =>
            import('../components/accept-contest/MobileAcceptContest'),

        WideAcceptContest: Stub,
    },
    created() {
        if ( ! this.user.id)
            return window.location = process.env.VUE_APP_AUTH;

        this.loadContest(this.$route.params.id);
    },
};
</script>

<style lang="scss" scoped>
</style>
